<template>
  <v-layout row wrap white pl-4>
    <v-flex xs5>
      <v-autocomplete
        ref="searchAutofocus"
        :height="`${condominium_ids.length ? 'auto' : '33px'}`"
        v-model="condominium_ids"
        :disabled="isUpdating"
        :items="condominiums"
        hide-selected
        :menu-props="{ closeOnContentClick: true }"
        chips
        persistent-hint
        label="Condomínios"
        item-text="name_fantasy"
        item-value="condominium_id"
        multiple
      >
        <template v-slot:selection="data">
          <v-chip
            :selected="data.selected"
            close
            class="chip--select-multi"
            @input="removeCond(data.item)"
          >
            <v-avatar>
              <img :src="data.item.avatar" />
            </v-avatar>
            {{ data.item.name_fantasy }}
          </v-chip>
        </template>
        <template v-slot:item="data">
          <template v-if="typeof data.item !== 'object'">
            <v-list-tile-content v-text="data.item"></v-list-tile-content>
          </template>
          <template v-else>
            <v-list-tile-avatar>
              <img :src="data.item.avatar" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                v-html="data.item.name_fantasy"
              ></v-list-tile-title>
              <v-list-tile-sub-title
                v-html="data.item.name_company"
              ></v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </template>
      </v-autocomplete>
    </v-flex>
    <v-flex xs3 ml-4 :class="[condominium_ids.length ? 'mt-2' : '']">
      <v-text-field
        v-model="name"
        label="Nome do documento"
        append-icon="search"
        @click:append="search"
        v-on:keydown.enter.prevent="search"
      />
    </v-flex>
    <v-flex xs12 text-xs-left>
      <v-switch
        color="success"
        class="pt-0 mt-0 smallSwitch"
        v-model="showInactiveDocuments"
        label="Exibir apenas documentos inativos"
      ></v-switch>
      <!-- :label="showInactiveDocuments ? 'Não exibir os documentos inativos' : 'Exibir apenas documentos inativos'" -->
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      showInactiveDocuments: false,
      condominiums: [],
      condominium_ids: [],
      isUpdating: false,
      name: "",
    };
  },
  props: {
    searchDocumentations: Function,
  },
  watch: {},
  mounted() {
    this.getComdominiums();
  },
  methods: {
    getComdominiums() {
      let obj = {
        url: "/api/get_list",
        query: "",
        method: "get",
        noLoader: true,
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        this.condominiums = response.data;
        let obj = { condominiums: response.data };
        this.$store.commit("condominiums/updateCondominiumList", obj);
        this.$props.condominiumList = response.data;
      });
    },
    search() {
      // if (!this.condominium_ids.length) {
      //   this.$refs.searchAutofocus.focus();
      //   return;
      // }
      this.$props.searchDocumentations({
        flag_active: this.showInactiveDocuments,
        name: this.name,
        condominium_id: this.condominium_ids,
      });
    },
    removeCond(item) {
      //console.log(item);
      const index = this.condominium_ids.indexOf(item.condominium_id);
      if (index >= 0) this.condominium_ids.splice(index, 1);
    },
  },
};
</script>

<style>
</style>